export const sortSelectedFirst = (
    data: string[],
    selected: string[],
): string[] => {
    return data.toSorted((a, b) => {
        const aSelected = selected.includes(a);
        const bSelected = selected.includes(b);

        if (aSelected !== bSelected) {
            return aSelected ? -1 : 1;
        }

        return a.localeCompare(b);
    });
};
